// extracted by mini-css-extract-plugin
module.exports = {"ctn":"SideMenu_ctn__Z8YdG","ctnUser":"SideMenu_ctnUser__1d0E4","ctnFixed":"SideMenu_ctnFixed__1fQ6j","divTitle":"SideMenu_divTitle__3q2D7"};